import { Col, Row, Space, Typography, Back } from "@bezlimit/bezlimit-ui";
import { observer } from "mobx-react";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import "./style.scss";
// services
import NotificationsService from "../../../../../../services/NewsService";
// core
import { IItems } from "../../../../../../core/models/News";
import date from "../../../../../../core/functions/date";
import { ModalContext } from "../../../../../../core/Contexts";
// ui
import Loading from "../../../../../blocks/ui/loading";

export default observer(function NewsDescription() {
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();
    const [state, setState] = useState<IItems | undefined>();
    const [localLoading, setLocalLoading] = useState(true); 
    const contextModal = useContext(ModalContext);
    const contentRef = useRef<HTMLDivElement>(null);

    const dateFormat: Intl.DateTimeFormatOptions = {
        month: "long",
        day: "numeric"
    };

    const getNews = useCallback(async (id: string | undefined) => {
        if (!id) return;

        const res: IItems = await NotificationsService.getNewsById(id);
        NotificationsService.postRead(id);
        NotificationsService.getNewsCount();
        setState(res);
    }, []);

    useEffect(() => {
        setLocalLoading(true); 
        getNews(id);

        const timer = setTimeout(() => {
            setLocalLoading(false);
        }, 1500);

        return () => clearTimeout(timer);
    }, [id, getNews]);

    useEffect(() => {
        if (!state?.title) {
            return;
        }
        document.title = `${state.title} | Store`;
    }, [state]);

    useEffect(() => {
        const container = contentRef.current;
        if (!container || !state) return;

        const handleImageClick = (e: MouseEvent) => {
            const target = e.target as HTMLImageElement;
            if (target.tagName === 'IMG') {
                contextModal?.setVisible(true);
                contextModal?.setCssClass("photo-news-wrapper");
                contextModal?.setChildren(<img src={target.src} alt="news" />);
                const modalMask: HTMLDivElement = document.querySelector(".ant-modal-mask")!;
                if (modalMask) {
                    modalMask.style.background = "#1e1817e8";
                }
            }
        };

        container.addEventListener('click', handleImageClick);

        return () => {
            container.removeEventListener('click', handleImageClick);
            contextModal?.setVisible(false);
        };
    }, [state, contextModal]);

    if (localLoading) {
        return <Loading visible={true} />;
    }

    return (
        <Typography as="div" className="bl-news-discription">
            <Back navigate={() => navigate("/news")}>{""}</Back>
            {state && (
                <Row>
                    <Col span={24}>
                        <Row>
                            <Space direction="vertical" size={22}>
                                <Col>
                                    <Typography
                                        className="block-title"
                                        size={48}
                                        fontFamily="alumna"
                                    >
                                        {t(state.title)}
                                    </Typography>
                                </Col>
                                <Col>
                                    <Typography className="preview-text">
                                        {t(state.preview_text)}
                                    </Typography>
                                </Col>
                                <Row justify="start">
                                    <Typography
                                        className="published-date"
                                        color="rgba(255, 255, 255, 0.5)"
                                        size={14}
                                        appearance="medium"
                                    >
                                        {t(date(state.published_date, dateFormat)) +
                                            " " +
                                            state.published_date.split("-")[0] +
                                            " года"}
                                    </Typography>
                                </Row>
                                <Col>
                                    <div ref={contentRef}>
                                        <Typography
                                            className="text-news"
                                            dangerouslySetInnerHTML={{ __html: t(state.text) }}
                                        ></Typography>
                                    </div>
                                </Col>
                            </Space>
                        </Row>
                    </Col>
                </Row>
            )}
        </Typography>
    );
});